module.exports = __webpack_public_path__ + "img/php.8c9b6a58.png";